import * as React from 'react';

function SvgFrontOfBus(props) {
  return (
    <svg viewBox="0 0 45.437 45.437" width="1em" height="1em" {...props}>
      <path d="M41.403 11.11c-.371-3.627-.962-6.451-1.897-7.561-3.855-4.564-30.859-4.898-33.925 0-.75 1.2-1.276 4.014-1.629 7.567a2.287 2.287 0 00-2.026 2.267v4.443a2.29 2.29 0 001.5 2.146c-.207 6.998-.039 14.299.271 17.93 0 2.803 1.883 2.338 1.883 2.338h1.765v3.026c0 1.2 1.237 2.171 2.761 2.171 1.526 0 2.763-.971 2.763-2.171V40.24h20.534v3.026c0 1.2 1.236 2.171 2.762 2.171 1.524 0 2.761-.971 2.761-2.171V40.24h.58s2.216.304 2.358-1.016c0-3.621.228-11.646.04-19.221a2.28 2.28 0 001.607-2.177v-4.443a2.284 2.284 0 00-2.108-2.273zM12.176 4.2h20.735v3.137H12.176V4.2zm.296 32.467a2.947 2.947 0 110-5.895 2.947 2.947 0 010 5.895zm20.328 0a2.948 2.948 0 11-.002-5.892 2.948 2.948 0 01.002 5.892zm3.747-12.9H8.54V9.077h28.007v14.69z" />
    </svg>
  );
}

export default SvgFrontOfBus;
